<template>
  <div class="social-wrapper">
    <img src="../../assets/images/shebao.png" alt="">
    <div class="social-btn-wrapper">
      <button class="social-btn" @click="goDetail">开通电子社保卡</button>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { getAuth } from '@/api/social'
import { setStore } from '@/utils/index'
export default {
  data () {
    return {

    }
  },
  mounted () {
    const accessToken = this.$route.query.accessToken
    if (accessToken) {
      setStore('token', accessToken)
    }
  },
  methods: {
    goDetail () {
      getAuth().then((res) => {
        console.log(res)
        // eslint-disable-next-line no-undef
        /* eslint-disable */
        if (res.data.code === 200) {
          const data = res.data.result
          if (data && data.nameAuth === 1 && data.faceAuth === 1) {
            console.log('已认证')
            dsBridge.call('callNativeView', {
              'androidGoPage': '/social/InsuranceSearchActivity',
              'iosGoPage': 'GXSheBaoMainViewController'
            })
          } else if (data && data.nameAuth === 1 && data.faceAuth !== 1) {
            dsBridge.call('callFaceAuthen', function (token) {
              console.log('原生认证成功')
              dsBridge.call('callNativeView', {
                'androidGoPage': '/social/InsuranceSearchActivity',
                'iosGoPage': 'GXSheBaoMainViewController'
              })
            })
          } else if (data && data.faceAuth === 1 && data.nameAuth !== 1) {
            dsBridge.call('callNameAuthen', function (token) {
              console.log('原生认证成功')
              dsBridge.call('callNativeView', {
                'androidGoPage': '/social/InsuranceSearchActivity',
                'iosGoPage': 'GXSheBaoMainViewController'
              })
            })
          } else if (data) {
            dsBridge.call('callNameAndFaceAuthen', function (token) {
              console.log('原生认证成功')
              dsBridge.call('callNativeView', {
                'androidGoPage': '/social/InsuranceSearchActivity',
                'iosGoPage': 'GXSheBaoMainViewController'
              })
            })
          } else {
            Toast('接口报错')
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.social-wrapper {
  width: 100%;
  background: #fee1c6;
  padding-bottom: 20px;
  img {
    width: 100%;
  }
}
.social-btn-wrapper {
  display: flex;
  justify-content: center;
  margin: 20px 20px;
}
.social-btn {
  box-sizing: border-box;
  width: 100%;
  padding: 8px;
  background: #ff7835;
  color: #fff;
  border-radius: 40px;
  font-size: 16px;
}

</style>
